import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "timer",
  "use": "timer-usage",
  "viewBox": "0 0 20 23",
  "content": "<symbol viewBox=\"0 0 20 23\" id=\"timer\"><path d=\"M17.294 6.485c-1.333-1.357-2.925-2.224-4.629-2.564V3.47h.185c.408 0 .704-.34.704-.754v-2.3A.415.415 0 0 0 13.147 0H8.48a.415.415 0 0 0-.408.415v2.3c0 .415.333.754.704.754h.185v.452c-1.704.377-3.333 1.207-4.63 2.564-.036.038-.073.076-.073.113l-.482-.528.556-.565-1.593-1.66L0 6.637l1.592 1.66.556-.566.704.754c-2.037 3.62-1.556 8.332 1.48 11.424a9.007 9.007 0 0 0 13 0c3.554-3.733 3.554-9.728-.038-13.423zM15.85 18.362a6.976 6.976 0 0 1-10.073 0C3 15.497 3 10.86 5.777 7.956a6.976 6.976 0 0 1 10.073 0c2.777 2.865 2.777 7.54 0 10.406zm-1.852-8.257L11.85 12.97a1.09 1.09 0 0 1-.296.98 1.037 1.037 0 0 1-1.481 0c-.407-.414-.407-1.093 0-1.545a.972.972 0 0 1 .815-.302l2.814-2.262c.222-.189.445.075.296.264z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/timer.svg
// module id = ./src/assets/icons/timer.svg
// module chunks = 4